module.exports = {
    name: 'Maarten Kuijper',
    email: 'maarten@activecreations.nl',
    comments: "Test\nNieuwe regel <b>tëst</b>",
    phonenumber: '038-3869367',
    street: 'Mastenmakersstraat 15-17',
    zipcode: '8064DX',
    city: 'Zwartsluis',
};
